import RequestApi from "../../utils/request";

export default {
	//初始化
	GetInit:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/GetInit/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//会员注册
	MemberRegister:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/MemberRegister/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
    //会员登录
    MemberCheckIn:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/MemberCheckIn/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//会员退出
	MemberCheckOut:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/MemberCheckOut/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//重置密码
	MemberResetPassword:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/MemberResetPassword/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//保存头像
	MemberSaveAvatar:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/MemberSaveAvatar/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//修改会员信息
	MemberUpdateInfo:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/MemberUpdateInfo/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取积分兑换
	GetExchangePopover:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/GetExchangePopover/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//兑换视频
	ExchangeVideo:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/ExchangeVideo/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取我的视频
	GetMyVideoList:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/GetMyVideoList/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//播放我的视频
	PlayMyVideoFile:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Member/PlayMyVideoFile/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},


}